import classNames from 'classnames';
import styles from './ApplicationQuery.module.css';
import { Button, Space, Form, Modal } from 'antd';
import { useState, useRef, useEffect } from 'react';
import SessionDefinition from 'src/components/Query/SessionDefinition';
import VehicleDefinition from '../../components/Query/VehicleDefinition';
import ApplicationDefinition from 'src/components/Query/ApplicationDefinition';
import FinalSummary from 'src/components/Query/FinalSummary';
import { getFinalResultCost } from 'src/app/query.service';
import type { FormInstance } from 'antd/es/form';

interface FormData {
  [key: string]: any;
}
interface Cost {
  queryCost: string;
  isCostThresholdCrossed: boolean;
}
interface ResettableComponent {
  reset: () => void;
}

const ApplicationQuery = () => {
  const [activeComponent, setActiveComponent] = useState<number>(1);
  const [formData, setFormData] = useState<FormData>({});
  const [form] = Form.useForm<FormInstance>();
  const [finalStep, setFinalStep] = useState(false);
  const [costData, setCostData] = useState<Cost[]>([]);
  const [isModalOpen, setModal] = useState(false);
  const sessionRef = useRef<ResettableComponent>(null);
  const vehicleRef = useRef<ResettableComponent>(null);
  const applicationRef = useRef<ResettableComponent>(null);
  const handleNext = (newData: FormData) => {
    console.log('formData next', newData);

    setFormData((prevData) => ({ ...prevData, ...newData }));
    setActiveComponent((prevActiveComponent) => prevActiveComponent + 1);
  };
  const applicationDefinitionData = (newData: FormData) => {
    setFormData((prevData) => ({ ...prevData, ...newData }));
  };

  const handleBack = () => {
    console.log('formData back', formData);
    setActiveComponent((prevActiveComponent) => prevActiveComponent - 1);
  };
  const handleBack2 = () => {
    console.log('formData', formData);
  };
  const [payload, setPayload] = useState<FormData>({});

  const generatePayload = () => {
    const postdata = {
      applicationId: formData.applicationId || null,
      applicationCompletionStatus: formData.applicationCompletionStatus || null,
      durationMin: formData.durationMin || null,
      durationMax: formData.durationMax || null,
      hardwarePartNumber: formData.hardwarePartNumber || null,
      softwarePartNumber: formData.softwarePartNumber || null,
      ecuCalibrationNumber: formData.ecuCalibrationNumber || null,
      ecuSerialNumber: formData.ecuSerialNumber || null,
      dateFrom: formData.dateFrom || null,
      dateTo: formData.dateTo || null,
      sourceSoftwareVersion: formData.sourceSoftwareVersion || null,
      sourceType: formData.sourceType || null,
      bodyStyle: formData.bodyStyle || null,
      brand: formData.brand || null,
      driver: formData.driver || null,
      emission: formData.emission || null,
      engine: formData.engine || null,
      enginePowertrainDescription: formData.enginePowertrainDescription || null,
      market: formData.market || null,
      model: formData.model || null,
      modelYear: formData.modelYear || null,
      plant: formData.plant || null,
      trim: formData.trim || null,
      transmission: formData.transmission || null,
      vin: formData.vin || null,
      dateRangeOverriden: formData.dateRangeOverriden || null,
    };
    setPayload(postdata);
    return postdata;
  };

  const handleStart = async () => {
    const postData: FormData = generatePayload();

    try {
      const vinArray = Array.isArray(postData.vin) ? postData.vin : [];

      // If VINs are provided, skip cost check
      if (vinArray.length > 0) {
        setFinalStep(true);
        return;
      }

      const result: Cost[] = await getFinalResultCost<Cost>('application', 'final/cost', postData);
      setCostData(result);

      if (result[0]?.isCostThresholdCrossed) {
        setModal(true);
      } else {
        setFinalStep(true);
      }
    } catch (error) {
      console.log('error fetching cost...', error);
    }
  };

  useEffect(() => {
    if (costData[0]?.isCostThresholdCrossed) {
      setModal(true);
    }
  }, [costData]);

  const handleCancel = () => {
    setModal(false);
  };
  const handleStartQuery = () => {
    setModal(false);
    setFinalStep(true);
  };

  const handleReset = () => {
    form.resetFields();
    setFormData({});
    setActiveComponent(1);
    if (sessionRef.current) {
      sessionRef.current.reset();
    }
    if (vehicleRef.current) {
      vehicleRef.current.reset();
    }
    if (applicationRef.current) {
      applicationRef.current.reset();
    }
  };
  return (
    <div className={classNames(styles.ApplicationQuery)}>
      {!finalStep && (
        <>
          <SessionDefinition
            ref={sessionRef}
            isActive={activeComponent === 1}
            onNext={handleNext}
            form={form}
            queryType="application"
          />
          <VehicleDefinition
            ref={vehicleRef}
            isActive={activeComponent === 2}
            onBack={handleBack}
            onNext={handleNext}
            propData={formData}
            form={form}
            queryType="application"
          />
          <ApplicationDefinition
            ref={applicationRef}
            isActive={activeComponent === 3}
            onBack={handleBack}
            propData={formData}
            form={form}
            queryType="application"
            handleNext={applicationDefinitionData}
          />
          <div>
            <Space>
              <Button onClick={handleStart} className={styles['ApplicationQuery--Buttons']}>
                Start
              </Button>
              <Button className={styles['ApplicationQuery--Buttons']}>Reset</Button>
            </Space>
          </div>
        </>
      )}
      {finalStep && (
        <FinalSummary
          onBack={() => {
            setFinalStep(false);
            handleBack2();
          }}
          queryType="application"
          propData={payload}
          filename="Application_export"
        />
      )}
      <Modal
        title={<h3 style={{ display: 'inline' }}>Query Cost Calculation</h3>}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <div>
          Please be advised, this query may cost the company up to $ {costData[0]?.queryCost}. You
          can press &quto;Back&quto; to reduce this Cost by using a smaller date range and/or using
          specific VINs in you query. Please ensure this is business critical before selecting
          Start.
        </div>
        <div style={{ width: '100%' }}>
          <Button
            onClick={() => {
              setModal(false);
              setFinalStep(true);
            }}
            className="ApplicationQuery--Buttons"
          >
            Start Query
          </Button>
          <Button
            onClick={() => setModal(false)}
            className="ApplicationQuery--Buttons"
            style={{ float: 'right' }}
          >
            Back
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ApplicationQuery;
